import { render, staticRenderFns } from "./paymentBig.vue?vue&type=template&id=65f8f646&scoped=true"
import script from "./paymentBig.vue?vue&type=script&lang=js"
export * from "./paymentBig.vue?vue&type=script&lang=js"
import style0 from "./paymentBig.vue?vue&type=style&index=0&id=65f8f646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f8f646",
  null
  
)

export default component.exports